import { ExamModeEnum } from '../exam';

// 定死变量
export enum ExamSubject {
  /**
   * 软考定死的一级分类id（黄奎说永远不会改）
   */
  RkFirstSubject = 554,
}

export enum CollectionType {
  AllFavorites = '0', // 全部收藏
  TodayFavorites = '1', // 今日收藏
}

export enum CorrectionType {
  Unprocessed = 0, // 纠错未处理
  Processed = 1, // 纠错已处理
}

export enum HighFrequencyType {
  AllMistakes = 0, // 全部错题
  HighFrequencyMistakes = 1, // 高频错题
}
